import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function ForecastDay(props) {

  function formatDay(timestamp) {
    let date = new Date(timestamp * 1000);
    let days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

    return days[date.getDay()];
  }

  return (
    <div className="ForecastDay text-center">

      <div className="forecast-day">
        {formatDay(props.data.time)}
      </div>

      <WeatherIcon code={props.data.condition.icon} size={36} />

      <div className="forecast-temperatures">
        <span className="forecast-temp-max">
          {Math.round(props.data.temperature.maximum)}°
        </span>

        <span className="forecast-temp-min">
          {Math.round(props.data.temperature.minimum)}°
        </span>
      </div>

    </div>
  );
}